import { render, staticRenderFns } from "./UniversityTemplateIndex.vue?vue&type=template&id=f63d0642&scoped=true&"
import script from "./UniversityTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./UniversityTemplateIndex.vue?vue&type=script&lang=js&"
import style0 from "./UniversityTemplateIndex.vue?vue&type=style&index=0&id=f63d0642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d0642",
  null
  
)

export default component.exports